import {Base,Axios} from "@/api/Base"

export class GiDownGeneralInsurance extends Base {

    path = "gi/downGeneralInsurance"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}